import { useMemo } from "react";
import { GridFilterModel, GridLogicOperator } from "@mui/x-data-grid";
import { customDataGridApplyFilters } from "../../../Utils/js-common";

export const useFilteredRows = (rows: any[], filterModel: GridFilterModel) => {
  return useMemo(() => {
    const criteria = filterModel.items.map((item) => ({
      key: item.field,
      operator: item.operator as any,
      value: item.value
    }));
    const logicOperator = filterModel.logicOperator ?? GridLogicOperator.And;
    return customDataGridApplyFilters<any[]>(rows, criteria, logicOperator);
  }, [rows, filterModel.items, filterModel.logicOperator]);
};